import * as React from 'react'

import Icon from '@material-ui/icons/ChevronRight'
import './style.scss'

interface IProps {
  key: string
  title: string
  subtitle?: string
  action?: any
  icon?: any
}

export class DefaultLinkButton extends React.Component<IProps> {
  render() {
    const { title, subtitle, action, key, icon } = this.props
    return (
      <div
        key={key}
        className="default-link"
        onClick={() => (action ? action() : undefined)}
      >
        <div className="default-link-text">
          {title}
          {subtitle && <p>{subtitle}</p>}
        </div>
        <div className="default-link-icon">{icon ? icon : <Icon />}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DefaultLinkButton/index.tsx